import {
  GET_TITLES,
  GET_TITLES_FAIL,
  GET_TITLES_SUCCESS,
  ADD_NEW_TITLE,
  ADD_TITLE_SUCCESS,
  ADD_TITLE_FAIL,
  UPDATE_TITLE,
  UPDATE_TITLE_SUCCESS,
  UPDATE_TITLE_FAIL,
  DELETE_TITLE,
  DELETE_TITLE_SUCCESS,
  DELETE_TITLE_FAIL,
  
} from "./actionTypes";

export const getTitles = () => ({
  type: GET_TITLES,
})

export const getTitlesSuccess = titles => ({
  type: GET_TITLES_SUCCESS,
  payload: titles,
})

export const getTitlesFail = error => ({
  type: GET_TITLES_FAIL,
  payload: error,
})

export const addNewTitle = data => ({
  type: ADD_NEW_TITLE,
  payload: data,
})

export const addTitleSuccess = title => ({
  type: ADD_TITLE_SUCCESS,
  payload: title,
})

export const addTitleFail = error => ({
  type: ADD_TITLE_FAIL,
  payload: error,
})

export const updateTitle = title => ({
  type: UPDATE_TITLE,
  payload: title,
})

export const updateTitleSuccess = title => ({
  type: UPDATE_TITLE_SUCCESS,
  payload: title,
})

export const updateTitleFail = error => ({
  type: UPDATE_TITLE_FAIL,
  payload: error,
})

export const deleteTitle = data => ({
  type: DELETE_TITLE,
  payload: data,
})

export const deleteTitleSuccess = data => ({
  type: DELETE_TITLE_SUCCESS,
  payload: data,
})

export const deleteTitleFail = error => ({
  type: DELETE_TITLE_FAIL,
  payload: error,
})

